import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const SkeletonText = () => /*#__PURE__*/_jsx(View, {
  backgroundColor: "fill-secondary-disabled",
  blockSize: "0.8em",
  borderRadius: "300",
  "data-testid": "loading",
  display: "inline-block",
  inlineSize: "6em"
});